import React from 'react';
import { Section } from './Section';
import { XCircle, CheckCircle2 } from 'lucide-react';
const comparisons = [{
  bad: '⏰ 3-5 horas/semana planificando desde cero',
  good: '✅ 10 min/semana. El resto es entrenar.'
}, {
  bad: '😓 Siempre los mismos ejercicios → las jugadoras se aburren',
  good: '✅ 80+ ejercicios distintos → siempre hay algo nuevo'
}, {
  bad: '💸 Jugadoras que abandonan sin saber por qué',
  good: '✅ Sistema de progresión → retención visible'
}, {
  bad: '📋 Sin progresión clara de nivel a nivel',
  good: '✅ 6 tomos con progresión anual → mejoran y se quedan'
}, {
  bad: '😨 Jugadora con dificultad = pánico o improvisación',
  good: '✅ Protocolo de seguridad → actuás con confianza'
}, {
  bad: '👥 Niveles mezclados = caos de entrenamiento',
  good: '✅ Variaciones por nivel → todas mejoran juntas'
}, {
  bad: '📱 Sin sistema de comunicación con jugadoras y padres',
  good: '✅ Guía de marketing + 30 días de contenido planificado'
}, {
  bad: '💼 Sin identidad profesional visible',
  good: '✅ Sistema que justifica cobrar lo que merecés'
}];
export function CostComparison() {
  return <Section darker className="border-t border-gold-500/10" data-id="element-43">
      <div className="max-w-4xl mx-auto" data-id="element-44">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-center text-white mb-6 md:mb-12" data-id="element-45">
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <div className="bg-navy-900 rounded-2xl md:rounded-3xl border border-navy-700 overflow-hidden shadow-xl" data-id="element-46">
          <div className="grid grid-cols-2 bg-navy-800 border-b border-navy-700" data-id="element-47">
            <div className="p-3 md:p-6 text-center border-r border-navy-700" data-id="element-48">
              <span className="text-red-400 font-bold text-[10px] md:text-base tracking-wider uppercase" data-id="element-49">
                SIN PROFE DE VOLLEY RESUELTO
              </span>
            </div>
            <div className="p-3 md:p-6 text-center" data-id="element-50">
              <span className="text-green-400 font-bold text-[10px] md:text-base tracking-wider uppercase" data-id="element-51">
                CON PROFE DE VOLLEY RESUELTO
              </span>
            </div>
          </div>

          <div className="divide-y divide-navy-800/50" data-id="element-52">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-navy-800/20 transition-colors" data-id="element-53">
                <div className="p-3 md:p-6 border-r border-navy-800/50 flex items-center gap-2 md:gap-3" data-id="element-54">
                  <span className="text-gray-400 text-xs md:text-base" data-id="element-55">
                    {row.bad}
                  </span>
                </div>
                <div className="p-3 md:p-6 flex items-center gap-2 md:gap-3 bg-green-900/5" data-id="element-56">
                  <span className="text-white font-medium text-xs md:text-base" data-id="element-57">
                    {row.good}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}